import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { useUiStore } from '../stores/useUiStore'

export const notify = function (message, style = 'success') {
  toast(message, {
    theme: 'colored',
    type: style,
    position: 'top-center',
    pauseOnFocusLoss: false,
    hideProgressBar: true,
    autoClose: 2000,
    transition: 'slide',
    dangerouslyHTMLString: true,
  })
}

export const notif = function (message, style = 'success') {
  const uiStore = useUiStore()

  uiStore.alert.visible = true
  uiStore.alert.message = message
  uiStore.alert.style = style
}